module.exports = __webpack_public_path__ + "img/5.9335b373.png";